mutation DeleteMyYouTubeData {
  result: StreamToolsDeleteMyYouTubeData {
    completed
    purgedEvents
    message
  }
}
